import { GetterTree } from 'vuex';
import { SubsidyState, RootState } from '../types';

export const getters: GetterTree<SubsidyState, RootState> = {
	getSubsidies(state): Subsidy[] {
		return state.subsidies;
	},

	getSubsidyById: (state) => (id: number): Subsidy | undefined => {
		return state.subsidies.find(subsidy => subsidy.id === id);
	}
};